import { Component ,Inject ,HostListener, OnInit } from '@angular/core';
import { Config } from '../components/faqs/faqs.component';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ThanksDialogueComponent } from '../thanks-dialogue/thanks-dialogue.component';
import { CoursesService } from 'src/providers/courses.service';
import { Meta, Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { JSONIDService } from 'src/providers/schema';
import { LOCAL_STORAGE } from '@ng-toolkit/universal';
import SwiperCore, { Autoplay } from 'swiper';

SwiperCore.use([Autoplay]);

@Component({
  selector: 'app-idesign-arch',
  templateUrl: './idesign-arch.component.html',
  styleUrls: ['./idesign-arch.component.scss']
})

export class IdesignArchComponent {


  config: any = {
    slidesPerView: 4,
    spaceBetween: 20,
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },
    breakpoints: {
      0: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      }
    }
   
  };

 


  NID: any[] =[
    { img: 'https://media.iquanta.in/ui_images/idesign/idesign-topper-1.webp',},
    { img: 'https://media.iquanta.in/ui_images/idesign/idesign-topper-2.webp',},
    { img: 'https://media.iquanta.in/ui_images/idesign/idesign-topper-3.webp',},
    { img: 'https://media.iquanta.in/ui_images/idesign/idesign-topper-4.webp',},
    { img: 'https://media.iquanta.in/ui_images/idesign/idesign-topper-5.webp',},
    { img: 'https://media.iquanta.in/ui_images/idesign/idesign-topper-6.webp',},
    { img: 'https://media.iquanta.in/ui_images/idesign/idesign-topper-7.webp',},

    { img: 'https://media.iquanta.in/ui_images/idesign/idesign-topper-18.webp',},
    { img: 'https://media.iquanta.in/ui_images/idesign/idesign-topper-9.webp',},
    { img: 'https://media.iquanta.in/ui_images/idesign/idesign-topper-10.webp',},
    { img: 'https://media.iquanta.in/ui_images/idesign/idesign-topper-11.webp',},
    { img: 'https://media.iquanta.in/ui_images/idesign/idesign-topper-12.webp',},
    { img: 'https://media.iquanta.in/ui_images/idesign/idesign-topper-13.webp',},

  ];



  imgreviewlist :any[]=[
    {img:'https://media.iquanta.in/ui_images/iit-jee/Frame 4.png'},
    {img:'https://media.iquanta.in/ui_images/iit-jee/Frame 5.png'},
    {img:'https://media.iquanta.in/ui_images/iit-jee/Frame 6.png'},
    {img:'https://media.iquanta.in/ui_images/iit-jee/Frame 7.png'},
    {img:'https://media.iquanta.in/ui_images/iit-jee/Frame 8.png'},
    {img:'https://media.iquanta.in/ui_images/iit-jee/Frame 9.png'},
    {img:'https://media.iquanta.in/ui_images/iit-jee/Frame 10.png'},
    {img:'https://media.iquanta.in/ui_images/iit-jee/Frame 11.png'},
    {img:'https://media.iquanta.in/ui_images/iit-jee/Frame 12.png'},
    {img:'https://media.iquanta.in/ui_images/iit-jee/Frame 13.png'},
    {img:'https://media.iquanta.in/ui_images/iit-jee/Frame 14.png'},
    {img:'https://media.iquanta.in/ui_images/iit-jee/Frame 15.png'},
  ]
  
  imgreviewlist2:any[]=[
    {img:'https://media.iquanta.in/ui_images/iit-jee/Frame 15.png'},
    {img:'https://media.iquanta.in/ui_images/iit-jee/Frame 14.png'},
    {img:'https://media.iquanta.in/ui_images/iit-jee/Frame 13.png'},
    {img:'https://media.iquanta.in/ui_images/iit-jee/Frame 12.png'},
    {img:'https://media.iquanta.in/ui_images/iit-jee/Frame 11.png'},
    {img:'https://media.iquanta.in/ui_images/iit-jee/Frame 10.png'},
    {img:'https://media.iquanta.in/ui_images/iit-jee/Frame 9.png'},
    {img:'https://media.iquanta.in/ui_images/iit-jee/Frame 8.png'},
    {img:'https://media.iquanta.in/ui_images/iit-jee/Frame 7.png'},
    {img:'https://media.iquanta.in/ui_images/iit-jee/Frame 6.png'},
    {img:'https://media.iquanta.in/ui_images/iit-jee/Frame 5.png'},
    {img:'https://media.iquanta.in/ui_images/iit-jee/Frame 4.png'},
  ]

  faqList:any[] = [
    {
      name: 'Is the iQuanta master course for BITSAT exam helping students pass the exam?',
      iconClass: 'fa fa-code',
      active: true,
      submenu: [
        {answer: " The BITSAT master course is the best option for those who want to pass the BITSAT exam without any hassles. iQuanta BITSAT master course is the best available method that helps get through the BITSAT exam. ", subanswers: [] },
      ]
    },
     
    {
      name: 'Which is the best master course for BITSAT? ',
      iconClass: 'fa fa-mobile',
      active: false,
      submenu: [
        {answer: ' The best BITSAT master course for any individual who is interested in taking BITSAT is iQuanta. This course can be bought through the website of iQuanta at Rs 9999. Candidates will receive all live lectures after getting enrolled into this course.', subanswers: [] },
      ]
    },

    {
      name: 'How can I prepare for the BITSAT 2025 exam using mocks? ',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        {answer: ' To practice for the BITSAT 2025 exam, students must sign up for the iQuanta BITSAT master course 2025. ', subanswers: []},
      ]
    },

    {
      name: 'How can I obtain BITSAT 2025 last year question papers? ',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        {answer: " Within a few days of registration for the BITSAT master course 2025, the registered contestants to appear for the BITSAT 2025 examination will be provided with access to last year's question papers on their personal dashboards. ", subanswers: [] },
               ]
    },

    {
      name: 'How to prepare for 2025 BITSAT? ',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        {answer: ' Candidates will be prepared for the BITSAT 2025 by practicing the answers to as many numerical questions as possible, working through past years papers, taking practice tests, setting a daily schedule, creating a study plan basis on subjects, and so on. ', subanswers: [] },
      ]
    },
    {
      name: 'When is the main BITSAT exam held?   ',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        {answer: 'It is anticipated that the BITSAT 2025 exam will be administered in two sessions, one in May 2025 and the other in June 2025.', subanswers: [] },
      ]
    },
    {
      name: 'What is the maximum age that candidates for BITSAT Mains may be? ',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        {answer: '  The BITSAT mains 2025 exam has no upper age limit for applicants. However, in order to sit for the BITSAT mains exam, students must have passed the class 12 exam with the necessary scores.', subanswers: [] },
      ]
    },
    {
      name: 'When will the admit card for the BITSAT 2025 exam be made available? ',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        {answer: 'The admit card for the BITSAT 2025 exam will be made available three days prior to the exam day. Candidates must go to the official website to download their admission card.', subanswers: [] },
      ]
    },
    {
      name: 'How can I get the admit card for the BITSAT 2025 exam?  ',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        {answer: 'To download the BITSAT 2025 exam admit card, applicants must go to the exams official website and log in with their application number and birthdate.', subanswers: [] },
      ]
    },
    {
      name: 'How can I find out the BITSAT 2025 exam date, time, and location?   ',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        {answer: ' Candidates will receive information about the exams date, time, and location after downloading the BITSAT 2025 exam admit card. ', subanswers: [] },
      ]
    },
   
  ];


  jee2024: any[] =[
    { img: 'https://media.iquanta.in/ui_images/iit-jee/CHHITANSHU SHEKHAR (99.75).jpg', name: 'CHHITANSHU SHEKHAR', Marks: '99.75%ile', Registration: '' },
    { img: 'https://media.iquanta.in/ui_images/iit-jee/HIMANSHU KASANA (99.68).jpg', name: 'HIMANSHU KASANA ', Marks: '99.68%ile', Registration: '' },
    { img: 'https://media.iquanta.in/ui_images/iit-jee/NIkhil Yadav (99.55).jpg', name: 'NIkhil Yadav ', Marks: '99.55%ile', Registration: '' },
    { img: 'https://media.iquanta.in/ui_images/iit-jee/Kshitij bajpai 99.43.jpg', name: 'Kshitij bajpai ', Marks: '99.43%ile', Registration: '' },
    { img: 'https://media.iquanta.in/ui_images/iit-jee/VEDANT VIJAY PATIL (99.29).jpg', name: 'VEDANT VIJAY PATIL  ', Marks: '99.29%ile', Registration: '' },
    { img: 'https://media.iquanta.in/ui_images/iit-jee/OMKAR-NATH-SHUKLA-(99.29).jpg', name: 'OMKAR NATH SHUKLA ', Marks: '99.29%ile', Registration: '' },
    { img: 'https://media.iquanta.in/ui_images/iit-jee/SHAKSHAM PANDAY (99.22).jpg', name: 'SHAKSHAM PANDAY ', Marks: '99.22%ile', Registration: '' },
    { img: 'https://media.iquanta.in/ui_images/iit-jee/SHREYANSH PANDEY (99.22).jpg', name: 'SHREYANSH PANDEY  ', Marks: '99.22%ile', Registration: '' },
    { img: 'https://media.iquanta.in/ui_images/iit-jee/RAGHVENDRA MISHRA (99.18).jpg', name: 'RAGHVENDRA MISHRA ', Marks: '99.18%ile', Registration: '' },
    { img: 'https://media.iquanta.in/ui_images/iit-jee/PUNYAM-SWARUP-PADHI-(99.17).jpg', name: 'PUNYAM SWARUP PADHI ', Marks: '99.17%ile', Registration: '' },
    { img: 'https://media.iquanta.in/ui_images/iit-jee/PRANAY JAIN (99.12).jpg', name: 'PRANAY JAIN ', Marks: '99.12%ile', Registration: '' },
    { img: 'https://media.iquanta.in/ui_images/iit-jee/SHIVANGI-JAIN-(99.05).jpg', name: 'SHIVANGI JAIN  ', Marks: '99.05%ile', Registration: '' },
    { img: 'https://media.iquanta.in/ui_images/iit-jee/RAHUL PRATAP (99.0576839).jpg', name: 'RAHUL PRATAP ', Marks: '99.0576839%ile', Registration: '' },
    { img: 'https://media.iquanta.in/ui_images/iit-jee/Abhishek Bhangdiya (99).jpeg', name: 'Abhishek Bhangdiya ', Marks: '99%ile', Registration: '' },
    { img: 'https://media.iquanta.in/ui_images/iit-jee/Satyam Photo (99).jpg', name: 'Satyam  ', Marks: '99%ile', Registration: '' },
  

  ]

  jee2022: any[] =[
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_Arpitanilagarwal-20230206163442335532.jpg', name: 'Arpit Agrawal', Marks: '99.98%ile', Registration: '220310270785' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_CHINTALAKARTIKEYAKRISHNA20221103112140564631-20230208125020813513.jpg', name: 'Kartikeya Krishna', Marks: '99.96%ile', Registration: '220310431062' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_HIMANSHU-20230206163747483562.jpg', name: 'Himanshu Shekhar', Marks: '99.96%ile', Registration: '220310069290' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_SANATKUMARAGRAWAL-20230206164352819768.jpg', name: 'Sanat Agrawal', Marks: '99.95%ile', Registration: '220310022174' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_Bhawanishankarsaraswat-20230206163627554643.jpg', name: 'Bhawani Shankar Sarswat', Marks: '99.92%ile', Registration: '220310371138' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_KrishnakumarGupta-20230206163935999819.jpg', name: 'Krishna Gupta', Marks: '99.91%ile', Registration: '220310478749' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_KUMARUTKARSH-20230206163948423686.jpg', name: 'Kumar Utkarsh', Marks: '99.89%ile', Registration: '220310144081' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_SAKSHAM-20230206164335369227.jpg', name: 'Saksham', Marks: '99.84%ile', Registration: '220310005338' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_YASHGEHLOT-20230206164815586780.jpg', name: 'Yash Gehlot', Marks: '99.83%ile', Registration: '220310065102' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_ADWITIYAGOYAL20220901115255138185-20230208125451346320.jpg', name: 'A G', Marks: '99.81%ile', Registration: '220310052259' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_Yashtiwari20220901123219771081-20230208125655384645.jpg', name: 'Yt', Marks: '99.81%ile', Registration: '220310307541' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_SOUMYADIPPAIK-20230206164540345428.jpg', name: 'Soumyadip Paik', Marks: '99.81%ile', Registration: '220310116732' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_umanggarg-20230206164731930458.jpg', name: 'Umang Garg', Marks: '99.79%ile', Registration: '220310073768' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_SUJALPANDEY-20230206164601203149.jpg', name: 'Sujal Pandey', Marks: '99.79%ile', Registration: '220310224985' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_no-image.png', name: 'Subhojit Bhattacherjee', Marks: '99.78%ile', Registration: '220310152207' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_NUVVURUSAICHARANREDDY20221107200319851054-20230208125955700749.jpg', name: 'Sai Charan', Marks: '99.75%ile', Registration: '220310338517' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_JASHANPREETSINGH-20230206163820619714.jpg', name: 'Jashanpreet', Marks: '99.74%ile', Registration: '220310065079' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_no-image.png', name: 'Luv Sharma', Marks: '99.73%ile', Registration: '220310326104' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_GHUGEKARANVISHAL-20230206163716486898.jpg', name: 'Karan Ghuge', Marks: '99.68%ile', Registration: '220310543843' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_RAKESHKUMARCHANDRASHEKHARHONNALLI-20230206164156494297.jpg', name: 'Rakeshkumar', Marks: '99.66%ile', Registration: '220310264879' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_TANISHQSETH-20230206164702951076.jpg', name: 'Tanishq Seth', Marks: '99.59%ile', Registration: '220310386732' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_AyushmanMishra-20230206163559872918.jpg', name: 'Ayushman Mishra', Marks: '99.50%ile', Registration: '220310515474' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_ANEESHSINGHRAJORIYA-20230206163426316604.jpg', name: 'Aneesh Singh', Marks: '99.47%ile', Registration: '220310705986' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_AnanyaaAgrawal-20230206163348755193.jpg', name: 'Ananyaa Agrawal', Marks: '99.46%ile', Registration: '220310588414' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_SUREKANISHITRAHUL-20230206164638805324.jpg', name: 'Nishit Sureka', Marks: '99.45%ile', Registration: '220310756136' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_Shreyansh-20230206164518858567.jpg', name: 'Shreyansh', Marks: '99.44%ile', Registration: '220310057938' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_Junnarkarneelsubhash-20230206163855621573.jpg', name: 'Neel Junnarkar', Marks: '99.42%ile', Registration: '220310072826' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_SyedWahidAlam20221103113436665671-20230208130203311852.jpg', name: 'Wahid Alam', Marks: '99.41%ile', Registration: '220310348910' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_SHALEENGUPTA-20230206164438892592.jpg', name: 'Shaleen Gupta', Marks: '99.41%ile', Registration: '220310373915' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_ATHARVAPORWAL-20230206163532359526.jpg', name: 'Atharva Porwal', Marks: '99.40%ile', Registration: '220310255753' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_no-image.png', name: 'Satyendra Vishwakarma', Marks: '99.39%ile', Registration: '220310122734' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_SAUMYATRIPATHI-20230206164423595463.jpg', name: 'Saumya Tripathi', Marks: '99.29%ile', Registration: '220310104821' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_RajatMaliwal-20230206164120816711.jpg', name: 'Rajat Maliwal', Marks: '99.26%ile', Registration: '220310019955' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_Vignesh-20230206164750958287.jpg', name: 'Vignesh', Marks: '99.24%ile', Registration: '220310068540' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_TEJASVAJINDAL-20230206164720213697.jpg', name: 'Tejasva Jindal', Marks: '99.22%ile', Registration: '220310149761' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_SHANIKasaudhan20221103113047950708-20230208130512161244.jpg', name: 'Sunny Kasaudhan', Marks: '99.20%ile', Registration: '220310098813' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_PANCHALPREET-20230206164028323493.jpg', name: 'Panchal Preet', Marks: '99.18%ile', Registration: '220310008323' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_KUNALSHARMA-20230206164003651354.jpg', name: 'Kunal Sharma', Marks: '99.15%ile', Registration: '220310512674' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_GARGEYPANDEY20221107195146675801-20230208130355785421.jpg', name: 'Gargi Pandey', Marks: '99.15%ile', Registration: '220310532936' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_AYUSHDEBNATH-20230206163547117417.jpg', name: 'Ayush Debnath', Marks: '99.14%ile', Registration: '220310077201' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_YATHARTHVERMA-20230206164844122649.jpg', name: 'Yatharth Verma', Marks: '99.11%ile', Registration: '220310252534' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_ADITYAMEHTA-20230206163318725274.jpg', name: 'Aditya Mehta', Marks: '99.09%ile', Registration: '220310137115' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_Rahulprajapat-20230206164102313368.jpg', name: 'Rahul Prajapat', Marks: '99.08%ile', Registration: '220310275178' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_RakshitaAgrwal-20230206164315432705.jpg', name: 'Rakshita Agrawal', Marks: '99.08%ile', Registration: '220310180488' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_JashanGrover-20230206163800417063.jpg', name: 'Jashan Grover', Marks: '99.06%ile', Registration: '220310653031' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_GyanshuPathak-20230206163731847287.jpg', name: 'Gyanshu Pathak', Marks: '99.04%ile', Registration: '220310264309' },

  ]


  jee2021:  any[]=[
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_AbhisheksandipTalware-20210421224323521677.JPG', name: 'Abhishek', Marks: '99.94%ile', Registration: '210310095949' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_WhatsAppImage20210811at111747-20210811111812292651.jpeg', name: 'Rishi Joshi', Marks: '99.85%ile', Registration: '210310307634' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_WhatsAppImage20210807at145257-20210811110610262873.jpeg', name: 'Pradyuman Agarwal', Marks: '99.82%ile', Registration: '210310410362' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_AyushTomar-20210423152539861913.jpg', name: 'Ayush Tomar', Marks: '99.80%ile', Registration: '210310214295' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_MohitSharma-20210423163118265509.jpg', name: 'Mohit Sharma', Marks: '99.80%ile', Registration: '210310312887' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_HarshitJain-20210423161454763941.JPG', name: 'Harshit Jain', Marks: '99.78%ile', Registration: '210310062550' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_ANIKCHAKRABORTY-20210423152450652307.jpeg', name: 'Anik Chakraborty', Marks: '99.75%ile', Registration: '210310130325' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_IMG20210731204348Shubham-20210811112211986697.jpg', name: 'Aman Bansal', Marks: '99.69%ile', Registration: '210310511210' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_ShashankGhosh-20210423161105805533.jpg', name: 'Shaunak Ghosh', Marks: '99.62%ile', Registration: '210310071998' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_no-image.png', name: 'Aryan Tiwari', Marks: '99.55%ile', Registration: '210310019197' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_no-image.png', name: 'Harshit', Marks: '99.52%ile', Registration: '' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_RaghavSharma-20210811112703332620.jpeg', name: 'Raghav Sharma', Marks: '99.50%ile', Registration: '210310130057' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_ShahTakshilVipul-20210811110749974470.JPG', name: 'Takshil Shah', Marks: '99.48%ile', Registration: '210310112390' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_AnkitRaj-20210423152306156457.jpg', name: 'Ankit Raj', Marks: '99.37%ile', Registration: '210310459567' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_VaibhavDhanuka-20210423161815331445.jpeg', name: 'Vaibhav Dhanuka', Marks: '99.34%ile', Registration: '210310132477' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_IMG20210417150710compress16GauravChoudhary-20210811113148888934.jpg', name: 'Gaurav Choudhary', Marks: '99.33%ile', Registration: '210310187153' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_AnuragGupta-20210423161620555681.jpeg', name: 'Anurag Gupta', Marks: '99.32%ile', Registration: '210310102209' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_MohitTiwari-20210423162814891388.jpg', name: 'Mohit Tiwari', Marks: '99.25%ile', Registration: '210310239069' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_Husain-20210423161711658103.jpeg', name: 'Husain', Marks: '99.25%ile', Registration: '210310332693' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_WhatsAppImage20210809at1600311-20210811111720692222.jpeg', name: 'Kaushlendra Pratap Singh', Marks: '99.22%ile', Registration: '210310010029' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_divyanshgupta-20210423162702152041.jpeg', name: 'Divyansh Gupta', Marks: '99.20%ile', Registration: '210310003483' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_DevanshSengar-20210423162438729230.jpeg', name: 'Devansh Sengar', Marks: '99.17%ile', Registration: '210310066527' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_IMG20210708074416RakeshChoudhary-20210811113314987710.jpg', name: 'Rakesh Choudhary', Marks: '99.17%ile', Registration: '210310243947' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_IMG20210418235410LALITGIDWANI-20210811113729334760.jpg', name: 'Lalit Gidwani', Marks: '99.16%ile', Registration: '210310065842' },
    { img: 'https://media.iquanta.in/ui_images/atp-star/thumb_180_180_DHAWALARORA-20210423162513625259.jpeg', name: 'Dhawal Arora', Marks: '99.14%ile', Registration: '210310371611' }
  ]

  viewCount: any = 16;
  viewCount1: any = 16;
  viewCount2: any = 16;
  viewCount3: any = 24;
  viewCount4: any = 24;
  viewCount5: any = 24;
  viewCount6: any = 24;
  viewCount7: any = 24;
  viewCount8: any = 24;

  constructor( private _bottomSheet: MatBottomSheet ,public dialog: MatDialog, public coursesService: CoursesService , public titleService: Title, public metaService: Meta,
    @Inject(DOCUMENT) public dom:any, public schemaService: JSONIDService, @Inject(LOCAL_STORAGE) public sessionStorage:any ){
  }

  

  joinwhatsapp(){
    window.open('https://chat.whatsapp.com/F2X9OMVN8BSG9MARYpEKJ9', '_blank')
  }

  public scrolling = false;
  private timeout: any;
  @HostListener('window:scroll', ['$event'])
  onScroll(event:any) {
    this.scrolling = true;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.scrolling = false;
    }, 200);
  }

  coursesArray:any[]=[]
  getHomePageCourses() {
    this.coursesArray = [];
    this.coursesService.getPagewiseCourses('iDesign', 'landingpage', '2024').subscribe(res => {
      if (res.success) {
        if (res.data.length > 0) {
          this.coursesArray = res.data[0].course.filter((x:any)=> !x.is_rq);
        }
      }
    })
  }

  gotoSection(section:any){
    var elemnt: any = document.getElementById(section)
    elemnt.scrollIntoView({ behavior: "smooth" })
  }

  goToSection(val: any) {
    var elemnt: any = document.getElementById(val)
    elemnt.scrollIntoView({ behavior: "smooth" })

  }

  

  viewMore(val: any) {
    if (val == '1') {
      if (this.viewCount < this.jee2022.length) {
        this.viewCount = this.viewCount + 24;
      }
    } else if (val == '2') {
      if (this.viewCount1 < this.jee2021.length) {
        this.viewCount1 = this.viewCount1 + 24;
      }
    } else if (val == '3') {
      if (this.viewCount2 < this.jee2024.length) {
        this.viewCount2 = this.viewCount1 + 24;
      }
    }

  }

  viewLess(val: any) {
    if (val == '1') {
      this.viewCount = 24;
    } else if (val == '2') {
      this.viewCount1 = 24;
    } else if (val == '3') {
      this.viewCount2 = 24;
    } else if (val == '4') {
      this.viewCount3 = 24;
    } else if (val == '5') {
      this.viewCount4 = 24;
    } else if (val == '6') {
      this.viewCount5 = 24;
    } else if (val == '7') {
      this.viewCount6 = 24;
    } else if (val == '8') {
      this.viewCount7 = 24;
    } else if (val == '9') {
      this.viewCount8 = 24;
    }

  }
  json1:any;
  ngOnInit(): void {
    // this.getMocks()
    this.getHomePageCourses()
 
    this.json1 = this.schemaService.BArchBreadcrumbList;
          // Meta Data
          this.titleService.setTitle("iDesign: Best B.Arch Online Coaching by iQuanta");
          this.metaService.updateTag(
          { name: 'description', content: "Crack NATA exam with iQuanta’s B.Arch online coaching. Get personalized strategies, 24/7 doubt-solving, and comprehensive study materials to secure top design colleges."}); 
          this.metaService.updateTag( 
          { name: 'keywords', content: 'B.Arch Online Coaching,Best B.Arch Online course,nata course,nata coaching,nata online coaching,nata coaching classes,nata classes,nata preparation' });
          // Canonical Link
          const head = this.dom.getElementsByTagName('head')[0];
          var element: HTMLLinkElement = this.dom.createElement('link') as HTMLLinkElement
          head.appendChild(element);
          element.setAttribute('rel', 'canonical')
          element.setAttribute('href', 'https://www.iquanta.in/idesign/barch')
          // Facebook
          this.metaService.updateTag(
            { property: 'og:type', content: "website" })
          this.metaService.updateTag(
            { property: 'article:publisher', content: "https://facebook.com/iquanta.in" })
          this.metaService.updateTag(
            { property: 'og:title', content: "iDesign: Best B.Arch Online Coaching by iQuanta" })
          this.metaService.updateTag(
            { property: 'og:url', content: 'https://www.iquanta.in/idesign/barch' })
          this.metaService.updateTag(
            { property: 'og:description', content: "Crack NATA exam with iQuanta’s B.Arch online coaching. Get personalized strategies, 24/7 doubt-solving, and comprehensive study materials to secure top design colleges." });
          this.metaService.updateTag(
            { property: 'og:image:height', content: '720' })
          this.metaService.updateTag(
            { property: 'og:image:width', content: '1280' })
          this.metaService.updateTag(
            { property: 'og:image:type', content: 'image/webp' })
          this.metaService.updateTag(
            { property: 'og:image', content: 'https://media.iquanta.in/ui_images/nata.webp' })
          // Article Publish Time
          this.metaService.updateTag(
            { property: 'article:published_time', content: '2025-04-18T08:38:33+00:00' })
          // Twitter
          this.metaService.updateTag(
            { property: 'twitter:label2', content: "Est. reading time" })
          this.metaService.updateTag(
            { property: 'twitter:data2', content: "6 Minutes" })
          this.metaService.updateTag(
            { property: 'twitter:title', content: "iDesign: Best NATA Online Coaching by iQuanta" })
          this.metaService.updateTag(
            { property: 'twitter:url', content: 'https://www.iquanta.in/idesign/barch' })
          this.metaService.updateTag(
            { property: 'twitter:description', content: "Crack NATA exam with iQuanta’s B.Arch online coaching. Get personalized strategies, 24/7 doubt-solving, and comprehensive study materials to secure top design colleges." });
          this.metaService.updateTag(
            { property: 'twitter:image', content: 'https://media.iquanta.in/ui_images/nata.webp' })
          this.metaService.updateTag(
            { property: 'twitter:image:height', content: '720' })
          this.metaService.updateTag(
            { property: 'twitter:image:type', content: 'image/webp' })
          this.metaService.updateTag(
            { property: 'twitter:image:width', content: '1280' })
  
  if(this.dom.URL.includes('utm_source') || this.dom.URL.includes('utm_medium') || this.dom.URL.includes('utm_campaign')){
    this.sessionStorage.setItem('utmLink', this.dom.URL.split('?')[1])
  }
  }

  gotocourse() {
    var elemnt: any = document.getElementById('courses')
    elemnt.scrollIntoView({ behavior: "smooth" })
  }


  iquantaxatp(): void {
    this._bottomSheet.open(DashboardAssignments, {
      panelClass: 'modal-new',
    data: { type: 'iquantaxatp' },
    })
   
  }


  enquiryForm() {
    const dialog = this.dialog.open(GmatformComponent, {
      width: '390px',
      panelClass: 'skills-enquiry'
    })

    dialog.afterClosed().subscribe(result => {
      if (result.success) {
        const dialogRef = this.dialog.open(ThanksDialogueComponent, {
          width: '330px',
          panelClass: 'thanks-modal'

        })
        dialogRef.afterClosed().subscribe(res => {

        })

      }
    })
  }



}





@Component({
  selector: 'bottom-sheet-overview-example-sheet',
  templateUrl: 'dashboard-assignments-dialog.html',
  styleUrls: ['./idesign-arch.component.scss']
})
export class DashboardAssignments {
  constructor(private _bottomSheetRef: MatBottomSheetRef<DashboardAssignments>, @Inject(MAT_BOTTOM_SHEET_DATA) public data:any) {}

  openLink(event: MouseEvent)  {
    this._bottomSheetRef.dismiss();
    event.preventDefault();
  }

  close(){
    this._bottomSheetRef.dismiss();
  }
}




@Component({
  selector: 'app-gmatform',
  templateUrl: './gmatform.component.html',
  styleUrls: ['./idesign-arch.component.scss']
})
export class GmatformComponent {
  constructor(public dialogRef: MatDialogRef<GmatformComponent>,){}
  close() {
    this.dialogRef.close()
  }


}